import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// Styled Components
const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  flex-wrap: wrap;
  max-width:1445px;
  margin-top:1rem;
 margin :1px 2rem;
 padding: 1px 1rem;
 margin-bottom:1rem;

  @media(max-width: 768px) {
    flex-direction: column;
    padding: 0;
    margin: 0rem;
  }
    @media(max-width: 600px) {
padding-top:.5rem;
}
`;

const Poster = styled.div`
  flex: 1;
  position: relative;

  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 1.2rem;
  left: 1.2rem;
  background: rgba(0, 0, 0, 0.55);
  padding: 1rem;
  border-radius: 5px;
  color: white;
  max-width: 70%;

  h3 {
    margin: 0;
    font-size: 20px;
  }

  p {
    margin: 0.2rem 0 0.8rem;
    font-size: 14px;
    color: #eee;
  }

  button {
    background: #fff;
    color: #000;
    padding: 0.5rem 1.2rem;
    border: none;
    font-size: 14px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.3s;

    &:hover {
      background: #222;
      color: #fff;
    }
  }
  
`;

export default function DualPoster({ list = [] }) {


   const navigate = useNavigate()
  
    const handleNavigate=(id)=>{
  
    navigate(`/products/${id}`)
  
    }

    const isMobile = window.innerWidth <= 600;
  
 let mylist = isMobile? [list[1],list[3]]: [list[0],list[2]]; // Adjust the number of posters based on screen size
 
 



  return (
    <Wrapper>
     <Swiper
     autoplay={{ delay: 2000, disableOnInteraction: false }}
     loop={true}
      slidesPerView={1}
      pagination={{ clickable: true }}
      modules={[Autoplay]} 
     style={{height:isMobile? 331:399,width:'100%',overflow:'hidden',borderRadius:5,marginTop:0,marginBottom:0,padding:0,maxWidth:'1445px'}}
     >
      {mylist.map((item, index) => (
        <SwiperSlide key={index}>
          <Poster onClick={() => handleNavigate(item.id)}>
            <img src={item.imageUrl} alt={`Poster ${index + 1}`} />
         {/*    <Overlay>
              <h3>{item.title}</h3>
              <p>{item.subtitle}</p>
              <button>Order Now</button>
            </Overlay> */}
          </Poster>
        </SwiperSlide>
      ))}
     </Swiper>
    </Wrapper>
  );
}
